<app-search-bar (filterChanged)="emitFilter($event)"
  [fields]="fields"
  [formGroup]="form"
  [eagerModeFields]="['statuses']"
  [key]="key"
  [eagerModeHint]="'ORDERS.FILTERS.eager_hint' | translate">
  <div class="filter-grid">
    <div class="column">
      <div class="two-columns">
        <app-separator-input formControlName="outProjectId" syncControl>
          <app-separator-label>{{ 'ORDERS.FILTERS.project_ids' | translate }}</app-separator-label>
        </app-separator-input>

        <app-separator-input formControlName="outOrderId" syncControl>
          <app-separator-label>{{ 'ORDERS.FILTERS.order_ids' | translate }}</app-separator-label>
        </app-separator-input>
      </div>

      <app-separator-input formControlName="recipient" [byEntry]="true">
        <app-separator-label>{{ 'ORDERS.FILTERS.recipient_names' | translate }}</app-separator-label>
      </app-separator-input>

      <app-separator-input formControlName="phone" [byEntry]="true" syncControl>
        <app-separator-label>{{ 'ORDERS.FILTERS.phones' | translate }}</app-separator-label>
      </app-separator-input>

      <div class="two-columns">
        <app-separator-input formControlName="city" [byEntry]="true">
          <app-separator-label>{{ 'ORDERS.FILTERS.cities' | translate }}</app-separator-label>
        </app-separator-input>

        <app-separator-input formControlName="region" [byEntry]="true">
          <app-separator-label>{{ 'ORDERS.FILTERS.regions' | translate }}</app-separator-label>
        </app-separator-input>
      </div>

      <app-separator-input formControlName="postcode" syncControl>
        <app-separator-label>{{ 'ORDERS.FILTERS.postcodes' | translate }}</app-separator-label>
      </app-separator-input>

      <mat-form-field>
        <mat-label>{{ 'TABLE.comment' | translate }}</mat-label>
        <input formControlName="comment" matInput syncControl type="text">
      </mat-form-field>
    </div>

    <div class="column">
      <div class="two-columns">
        <app-separator-input formControlName="track" syncControl>
          <app-separator-label>{{ 'ORDERS.FILTERS.tracks' | translate }}</app-separator-label>
        </app-separator-input>

        <app-separator-input formControlName="tracking" [byEntry]="true" syncControl>
          <app-separator-label>{{ 'ORDERS.FILTERS.tracking_statuses' | translate }}</app-separator-label>
        </app-separator-input>
      </div>

      <app-select formControlName="couriers" multiple>
        <app-select-label>{{ 'ORDERS.COMMON.UNLOADING_BUTTON.courier_group' | translate }}</app-select-label>
        @for (courier of couriers$ | async; track courier) {
          <mat-option [value]="courier.id">{{ courier.name }}</mat-option>
        }
      </app-select>

      <app-select formControlName="senders" multiple>
        <app-select-label>{{ 'SENDERS.TABLE.title' | translate }}</app-select-label>
        @for (sender of senders$ | async; track sender) {
          <mat-option [value]="sender.id">{{ sender.name }}</mat-option>
        }
      </app-select>

      <app-select formControlName="statuses" multiple syncControl>
        <app-select-label>{{ 'COMMON.statuses' | translate }}</app-select-label>
        @for (status of statuses$ | async; track status) {
          <mat-option [value]="status.id">{{ status.name }}</mat-option>
        }
      </app-select>

      <div class="two-columns">
        <app-select formControlName="goods" multiple syncControl>
          <app-select-label>{{ 'COMMON.goods' | translate }}</app-select-label>
          @for (goods of goods$ | async; track goods) {
            <mat-option [value]="goods.id">{{ goods.name }}</mat-option>
          }
        </app-select>

        <mat-form-field>
          <mat-label>{{ 'ORDERS.COMMON.CART.total_quantity_tooltip' | translate }}</mat-label>
          <input formControlName="goodsCount" matInput type="number">
        </mat-form-field>
      </div>

      <app-select formControlName="storehouse" multiple>
        <app-select-label>{{ 'ORDER_PAGE.TABLE.store' | translate }}</app-select-label>
        @for (storehouse of storehouses$ | async; track storehouse) {
          <mat-option [value]="storehouse.id">
            {{ storehouse.name }}
          </mat-option>
        }
      </app-select>
    </div>

    <div class="column">
      <app-datetime-range formControlName="createdAt" [label]="'ORDERS.FILTERS.created' | translate">
      </app-datetime-range>
      <app-datetime-range formControlName="updatedAt" [label]="'ORDERS.FILTERS.updated' | translate">
      </app-datetime-range>
      <app-datetime-range formControlName="statusChangedAt" [label]="'ORDERS.FILTERS.status_changed' | translate">
      </app-datetime-range>
      <app-datetime-range formControlName="boughtOutAt" [label]="'ORDERS.DETAILS.paid' | translate">
      </app-datetime-range>
      <app-datetime-range formControlName="returnedAt" [label]="'ORDERS.DETAILS.returned' | translate">
      </app-datetime-range>
      <app-datetime-range formControlName="exportedAt" [label]="'ORDERS.FILTERS.exported' | translate">
      </app-datetime-range>
    </div>

    <div class="additions">
      <app-additional-fields-search [additionalFields]="additional"
        [extendedMode]="true"
        formGroupName="additions">
      </app-additional-fields-search>
    </div>
  </div>

  <app-user-filters class="r-side"
    (click)="$event.stopPropagation()"
    (applied)="changeUserFilter($event)"
    (reset)="resetUserFilter()"
    [fieldMap]="fieldMap">
  </app-user-filters>
</app-search-bar>
